<!--这个是后台下面内容组件-->
<template>
  <div class="right_content_dv">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {
    //声明组件名称
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" >
.right_content_dv {
  width: 100%;
  //background-color: #f1f4f5;
  background-color: #fff;
}

.content_dv {
  overflow-y:scroll;
  //background-color: #f1f4f5;
  background-color: #fff;
  width: 100%;
  padding-left: 220px;
  box-sizing: border-box;
  // height:868px;
  //min-height: 860px;
  //padding-top: 80px;
  padding-right: 20px;
  padding-bottom: 20px;
  .content_dv_dv {
    //padding: 0 0px 30px;
    box-sizing: border-box;
    background-color: #fff;
    height: 100%;
    //min-height: 860px;
    //box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.0980392156862745);
  }
}

.footer_common_dv{
  height:28px;
  line-height:28px;
  background-color:#f7f7f7;
  border-top: 1px solid #e5e5e5;
  box-shadow: 0 -2px 10px #f0f0f0;
  padding-left: 220px;
  padding-right:20px;
  box-sizing: border-box;
  p{
    font-size: 12px;
  }
}
</style>